/* tutor-1 (C): EL RENGLON DE ESTADO MIENTRAS CONTESTA: la chispa latiendo y "Pensando...", "Leyendo {{doc}}...",
   "Buscando en la web..." o "Leyendo tus fotos...". Se va con la primera palabra (lo decide la pagina).
   camara-pills remate (firma #720): la chispa en su renglon, encima del texto, como en la respuesta.

   ARCHIVO EN ASCII A PROPOSITO. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Chispa from './Chispa';

const LLAVES = { pensando: 'thinking', leyendo: 'reading', buscando: 'web', fotos: 'photos' };

export default function Estado({ estado }) {
  const { t } = useTranslation('study');
  const tipo = (estado && LLAVES[estado.tipo]) || 'thinking';
  const texto = tipo === 'reading'
    ? t('tutor.status.reading', { doc: (estado && estado.doc) || '' })
    : t(`tutor.status.${tipo}`);
  return (
    <div className="min-w-0 text-[13px] text-[#9A9A9A]" role="status" data-testid="tutor-estado" data-tipo={tipo}>
      <span className="flex h-6 mb-2"><Chispa late /></span>
      <span className="block">{texto}</span>
    </div>
  );
}
